declare global {
  interface Window {
    umami?: {
      track: (name: string, data?: Record<string, unknown>) => void;
    };
  }
}

export function track(name: string, data?: Record<string, unknown>): void {
  if (typeof window === "undefined") return;
  try {
    window.umami?.track(name, data);
  } catch {
    // umami not loaded yet or blocked — drop silently
  }
}

export interface AnalyticsConfig {
  src: string;
  websiteId: string;
}

export function loadUmamiScript(cfg: AnalyticsConfig): void {
  if (document.querySelector("script[data-umami-injected]")) return;
  const script = document.createElement("script");
  script.defer = true;
  script.src = cfg.src;
  script.dataset.websiteId = cfg.websiteId;
  script.dataset.umamiInjected = "true";
  document.head.appendChild(script);
}
